// @ts-nocheck

import { uniq as _uniq } from 'lodash';

import { MenuActionTypes } from '../types/actions/common';

export const menuInitialState = {};

export default (state = menuInitialState, action) => {
  switch (action.type) {
    case MenuActionTypes.ADD_KEY: {
      const { type, key } = action.payload;
      const { [type]: menu } = state;
      if (menu !== undefined) {
        let openKeys = menu.openKeys.slice();
        if (openKeys.indexOf(key) !== -1) {
          return {
            ...state,
            [type]: {
              openKeys: openKeys.filter((item) => {
                return item.indexOf(key) === -1;
              }),
            },
          };
        }
        openKeys = [];
        const parts = key.split('-');
        if (parts[0]) {
          openKeys.push(parts[0]);
        }
        if (parts[1]) {
          openKeys.push(`${parts[0]}-${parts[1]}`);
        }
        if (parts[2]) {
          openKeys.push(`${parts[0]}-${parts[1]}-${parts[2]}`);
        }
        return {
          ...state,
          [type]: {
            openKeys,
          },
        };
      }
      return {
        ...state,
        [type]: {
          openKeys: [key],
        },
      };
    }
    case MenuActionTypes.SET_KEY: {
      const { type, key } = action.payload;
      const { [type]: menu } = state;
      if (menu !== undefined) {
        const openKeys = menu.openKeys.slice();
        openKeys.push(key);
        return {
          ...state,
          [type]: {
            openKeys: _uniq(openKeys),
          },
        };
      }
      return {
        ...state,
        [type]: {
          openKeys: [key],
        },
      };
    }
    case MenuActionTypes.RESET:
      return {};
    default:
      return state;
  }
};
